const rfsTheme = {
  rfsRed: '#e5182B',
  darkRfsRed: 'rgb(141, 9, 0)',
  darkRfsRedBackground: 'rgb(141, 9, 0, 0.3)',
  errorTextColour: '#ab0000',
  rosterWeekendShade: '#f5f5f5',
  bodyBackgroundColour: 'rgb(240, 242, 245)',
};

export const shiftBackgroundColours = {
  day: rfsTheme.darkRfsRed,
  night: '#464749',
  vacantDay: '#f77d11',
  vacantNight: '#dc8200',
  violation: '#d70909',
};

export const lightTextColour = '#afafaf';
export const relatedNoteBackgroundColour = '#CBE2FF';

// Dark blue used for accessibility colouring on links
export const darkAccessibleLinkColour = '#00008b';

export default rfsTheme;
